/**
 * Ravinaaz Recently Viewed Products Tracker & Renderer
 * Matches 'You may also like' (related-products) section styling 1:1.
 */

(function () {
  'use strict';

  const RECENTLY_VIEWED_KEY = 'ravinaaz_recently_viewed';
  const MAX_ITEMS = 12;

  window.RavinaazRecentlyViewed = {
    get() {
      try {
        const data = localStorage.getItem(RECENTLY_VIEWED_KEY);
        return data ? JSON.parse(data) : [];
      } catch (e) {
        console.error('Error reading recently viewed products from localStorage', e);
        return [];
      }
    },

    save(items) {
      try {
        localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(items));
      } catch (e) {
        console.error('Error saving recently viewed products', e);
      }
    },

    add(product) {
      if (!product || (!product.id && !product.handle)) return;

      let items = this.get();
      const currentId = String(product.id || product.handle);

      // Remove duplicates if already recorded
      items = items.filter(item => String(item.id) !== currentId && item.handle !== product.handle);

      // Add to beginning of array
      items.unshift({
        id: String(product.id || product.handle),
        handle: product.handle,
        title: product.title,
        price: product.price,
        compare_at_price: product.compare_at_price || null,
        image: product.image,
        url: product.url,
        vendor: product.vendor || '',
        variantId: product.variantId || ''
      });

      // Keep only up to MAX_ITEMS
      if (items.length > MAX_ITEMS) {
        items = items.slice(0, MAX_ITEMS);
      }

      this.save(items);
    },

    clear() {
      this.save([]);
    }
  };

  // Automatically record current product on PDP load
  document.addEventListener('DOMContentLoaded', function () {
    if (window.RavinaazCurrentProduct) {
      window.RavinaazRecentlyViewed.add(window.RavinaazCurrentProduct);
    }

    // Render recently viewed grid if container exists
    window.renderRecentlyViewedSection();
  });

  // Function to render recently viewed section matching 'You may also like' layout
  window.renderRecentlyViewedSection = function () {
    const container = document.getElementById('recently-viewed-grid');
    const sectionElement = document.getElementById('recently-viewed-section');
    if (!container || !sectionElement) return;

    const limit = parseInt(container.dataset.limit || '4', 10);
    const currentProductHandle = window.RavinaazCurrentProduct ? window.RavinaazCurrentProduct.handle : null;

    let items = window.RavinaazRecentlyViewed.get();

    // Filter out currently viewed product if on product page
    if (currentProductHandle) {
      items = items.filter(item => item.handle !== currentProductHandle);
    }

    if (items.length === 0) {
      sectionElement.style.display = 'none';
      return;
    }

    sectionElement.style.display = 'block';

    const displayItems = items.slice(0, limit);

    container.innerHTML = displayItems.map(item => {
      const hasDiscount = item.compare_at_price && item.compare_at_price !== item.price;
      const isWishlisted = window.RavinaazWishlist ? window.RavinaazWishlist.exists(item.id) : false;

      return `
        <li class="grid__item">
          <div class="card-wrapper product-card-wrapper underline-links-hover rz-rv-card">
            <div class="card card--standard card--media">
              <div class="card__inner color-scheme-1 gradient">
                <button
                  type="button"
                  class="rz-wishlist-btn js-wishlist-btn ${isWishlisted ? 'is-active' : ''}"
                  aria-label="Add to Wishlist"
                  title="Add to Wishlist"
                  onclick="event.preventDefault(); event.stopPropagation();"
                  data-product-id="${item.id}"
                  data-product-handle="${item.handle}"
                  data-product-title="${item.title.replace(/"/g, '&quot;')}"
                  data-product-price="${item.price}"
                  data-product-compare-price="${item.compare_at_price || ''}"
                  data-product-image="${item.image}"
                  data-product-url="${item.url}"
                  data-product-vendor="${item.vendor.replace(/"/g, '&quot;')}"
                  data-variant-id="${item.variantId}"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                  </svg>
                </button>

                <div class="card__media">
                  <div class="media media--transparent media--hover-effect">
                    <img
                      src="${item.image || '//cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png'}"
                      alt="${item.title.replace(/"/g, '&quot;')}"
                      class="motion-reduce"
                      loading="lazy"
                      width="533"
                      height="666"
                    />
                  </div>
                </div>
              </div>

              <div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading h5">
                    <a href="${item.url}" class="full-unstyled-link">${item.title}</a>
                  </h3>
                  <div class="card-information">
                    <div class="price">
                      <div class="price__container">
                        <div class="price-item price-item--regular">${item.price}</div>
                        ${hasDiscount ? `<div class="price-item price-item--sale">${item.compare_at_price}</div>` : ''}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      `;
    }).join('');

    // Re-sync wishlist button state if wishlist module active
    if (window.RavinaazWishlist) {
      window.RavinaazWishlist.updateButtons();
    }
  };
})();
